import BpkText from '@skyscanner/backpack-web/bpk-component-text';

import type { ImageGuestType } from '@shared/types/hotel-information';

import STYLES from './TravellerLabel.module.scss';

import TRAVELLER_INFO from '@shared/ui/components/TravellerInfoMapping';

type Props = {
  guestType: ImageGuestType;
  travelInfo: string;
};

const TravellerLabel = ({ guestType, travelInfo }: Props) => {
  const IconLg = TRAVELLER_INFO[guestType] && TRAVELLER_INFO[guestType].iconLg;
  return (
    <section className={STYLES.TravellerLabel}>
      <div
        style={{
          backgroundColor: TRAVELLER_INFO[guestType]
            ? TRAVELLER_INFO[guestType].backgroundColor
            : 'none',
        }}
        className={STYLES.TravellerLabel__iconContainer}
      >
        {IconLg && <IconLg />}
      </div>
      <BpkText tagName="p">{travelInfo}</BpkText>
    </section>
  );
};

export default TravellerLabel;
